









import {
  PropType, defineComponent, ref, useFetch
} from '@nuxtjs/composition-api';
import { useProduct } from '~/composables';
import ProductsSlider from '~/modules/catalog/category/components/views/ProductsSlider.vue';

export default defineComponent({
  components: {
    ProductsSlider,
  },
  props: {
    skus: {
      type: Array as PropType<string[]>,
      default: () => ['xromdevtest', 'MX-CBBL-AL-STRCS', 'RG-BB2D-DUN-SNSN', 'MX-BB-VL-SL-CURTN-TENT'], // TODO: recently viewed
    },
    header: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { getProductList, loading } = useProduct();
    const products = ref([]);

    useFetch(async () => {
      const productsList = await getProductList({
        filter: {
          sku: {
            in: props.skus,
          },
        },
      });

      if (productsList?.items?.length) {
        products.value = productsList.items;
      }
    });

    return {
      products,
      loading,
    };
  },
});
